import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import LogoutIcon from '@mui/icons-material/ExitToApp';
import { Link } from 'react-router-dom';
import MenuItem from '../../components/Menu/MenuItem/MenuItem';
import Menu, { drawerWidth } from '../../components/Menu/Menu';
import Button from '@mui/material/Button';
import LanguageIcon from '@mui/icons-material/Language';
import ChooseLanguage from '../../../viewcontrollers/Splash/ChooseLanguage';
import { t } from 'i18next';

import Box from '@mui/material/Box';
import { width } from '@mui/system';
import { useTheme } from '@emotion/react';





/**
 * @param showNavigationMenu 
 * @param selectedValue
 * @param activeItem
 * @returns {*}
 */
const Navigation=(props)=>{
  const theme = useTheme();

  const styles = {
    menuOpen: {
      marginLeft: drawerWidth,
      //256 in xl mode
      [theme.breakpoints.down('sm')]: {
        marginLeft: '100vw',
      },
      [theme.breakpoints.down('xs')]: {
        marginLeft: '100vw',
      },
    },
    icons:{
      color:"#fff"
    }
  };
    /* state = {
      showNavigationMenu: this.props.showNavigationMenu,
    } */

    let [showNavigationMenu, setShowNavigationMenu] =useState(props.showNavigationMenu)

    /* static defaultProps = {
      showNavigationMenu: false,
      navigationItems: [],
      currentNavigationPath: '/',
    } */

    /* static propTypes = {
      devices: PropTypes.shape({}),
      activeDeviceId: PropTypes.string,
      showNavigationMenu: PropTypes.bool,
      currentNavigationPath: PropTypes.string,
      onSelectChange: PropTypes.func.isRequired,
      navigationItems: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
        icon: PropTypes.node,
      })).isRequired,
    } */

    const menuToggleHandler = () => {
      setShowNavigationMenu(!showNavigationMenu);
      props.handleDrawerState();
    }

    const getItemActive=(item, currentNavigationPath)=>{
      if(item.path === "/setupAuth"){
        if(currentNavigationPath === "/setup" || currentNavigationPath === item.path){
          return true
        } else {
          return false
        }
      } else {
        return (item.path === currentNavigationPath);
      }
    }

    const renderNavigationItems=()=>{
      const items = [];
      const currentNavigationPath = props.currentNavigationPath;
      props.navigationItems.forEach((item, idx) => {
       const isActive = getItemActive(item, currentNavigationPath)
        items.push(
          <Link to={item.path} style={{ textDecoration: 'none' }} key={`link-${idx}`}>
            <MenuItem key={`menuitem-${idx}`} label={item.label} icon={item.icon} active={isActive} drawerOpen={showNavigationMenu}/>
          </Link>,
        );
      });
      return items;
    }

    const handleLanguageIconClick= () => {
      // console.log('I got Clicked')
      props.openLanguageDialog()
    }


    // console.log("Rerender Navigation, open: ", this.state.langDialogOpen)
    return (
      <Box>
        <Menu
          open={showNavigationMenu}
          handleDrawerState={menuToggleHandler}
          onSelectChange={props.onSelectChange}
          devices={props.devices}
          activeDeviceId={props.activeDeviceId}>
          <List style={{ textDecoration: 'none', width:"100%", overflow:"hidden"}}>{renderNavigationItems()}</List>
          <ChooseLanguage open={props.langDialogOpen} close={props.closeLanguageDialog} />
          <List  style={{width:"100%", overflow:"hidden"}}>
            <Button onClick={handleLanguageIconClick}
              style={{ padding: '0px', textTransform: 'none', width: "100%" }} sx={{padding:0}}
              upperCase={false}>
              <MenuItem
                label={t('Misc.navigation_item_choose_language')}
                icon={(<LanguageIcon style={styles.icons} />)}
                drawerOpen={showNavigationMenu}
              ></MenuItem>
            </Button>
            <Link to="/logout" style={{ textDecoration: 'none', width:'100%', padding:0}}>
              <MenuItem label={t('Misc.navigation_item_logout')} icon={<LogoutIcon style={styles.icons}/>} drawerOpen={showNavigationMenu} />
            </Link>
          </List>
        </Menu>
      </Box>
    );
}

//export default withStyles(styles)(Navigation);
export default Navigation;
